import React from 'react';

import { OfferDesignFormValues } from 'views/OfferDesign/OfferDesign.types';

export const PERCENTAGE_LEFT_ICON: React.ReactElement = <span>%</span>;

export const getFormFieldValue = <T,>(
  values: OfferDesignFormValues,
  fieldName: string
): T | undefined => values[fieldName as keyof OfferDesignFormValues] as T | undefined;
